import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon, Popup } from 'semantic-ui-react';

import { connect } from 'react-redux';
import _ from 'lodash';
import getUser from './actions';
import Dropdown from '../../components/dropdown';
import { authService } from '../../utils/auth-service';
import TrialExpiredModal from '../../components/trial-expired';
import { reportError } from '../../utils/error-handling-service';

import ThemeSelector from '../../themes/theme-selector';

const organisationBlacklist = [
  'ad9f2dda-ff2a-4eb7-8e4a-ddbf00e046db',
  '692f214c-6a63-466e-b83d-a6c945050c9d',
  '45f827f2-96cd-4dad-bba3-5f97fb6321c5',
  // 'd2b05bec-dfc3-4b55-8a82-ec47bafacb7e', // Hansmann PR
  // '42516f65-6ce6-4606-a8aa-1174763590da', // ELEVATE
  '1c4e0611-e4fc-4522-833e-7a4905227908', // WIZDEO
  // '5b455a89-06e5-41dd-809f-ddda8bed1b4a', // ENDORSE SOCIAL
];

const ENTRY_SURVEY_STATUS = {
  mustComplete: 'MUST_COMPLETE',
};

const SuperAdminIcon = ({ name }) => (
  <Popup
    trigger={<Icon name="user circle outline" color="green" />}
    content={`${name} is a super admin`}
  />
);
const DYZIO_ORIGINS = ['https://app.dyzio.co', 'http://localhost:3000'];

const isOriginDyzio = origin => _.includes(DYZIO_ORIGINS, origin);
const userMustCompleteSurvey = organisation => organisation.entrySurveyStatus === ENTRY_SURVEY_STATUS.mustComplete;

class UserHandler extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  static propTypes = {
    user: PropTypes.object,
    onLoadUser: PropTypes.func.isRequired,
  };

  static defaultProps = {
    user: {},
  };

  componentWillMount() {
    return this.props.onLoadUser();
  }

  profileFeedback = action => {
    window.Intercom('shutdown');
    authService.logout();
    this.context.router.push(action);
  };

  render() {
    const { user, isLightOnDark } = this.props;
    let showTrialExpiredModal = false;

    const theme = ThemeSelector.theme();
    const hideOptions = theme.hideHomepage || false;

    const linkStyle = {
      fontWeight: 800,
      fontSize: '120%',
    };

    linkStyle.color = isLightOnDark ? '#FFF' : '#000';

    const chevronSrc = isLightOnDark ? '/icons/chevron-down-white.svg' : '/icons/chevron-down.svg';

    if (user && user.organisation) {
      if (_.includes(organisationBlacklist, user.organisation.id)) {
        console.log(`${user.organisation.id} is on our blacklist.`);
        reportError('TRIAL_EXPIRED_ERROR', `${user.name} was shown the trial expired screen.`);
        showTrialExpiredModal = true;
      } else {
        const { origin } = window.location;
        console.log(origin);
        console.log(`${user.organisation.id} is cleared for take-off.`);
        if (isOriginDyzio(origin) && userMustCompleteSurvey(user.organisation)) {
          this.context.router.push('/survey');
        }
      }
    }

    const errorStyle = {
      color: '#fdb02b',
    };
    if (user) {
      const { role } = user;
      const profile = authService.getProfile();
      const { enrolledBy, isUserSuperAdmin } = profile.app_metadata.dyzio;
      const isInfluencer = role === 'INFLUENCER';
      const selfEnrolled = isInfluencer && enrolledBy === 'SELF';
      const menuOptions = [];

      if (!selfEnrolled && !hideOptions) {
        menuOptions.push({
          name: 'Profile',
          action: () => this.context.router.push('/profile'),
        });
      }


      if (!isInfluencer && !hideOptions) {
        menuOptions.push({
          name: 'Manage Organisation',
          action: () => this.context.router.push('/team/manage'),
        });
      }

      if (!selfEnrolled && !hideOptions) {
        menuOptions.push({
          name: 'Notification preferences',
          action: () => this.context.router.push('/profile/settings'),
        });
      }

      if (isUserSuperAdmin && !hideOptions) {
        menuOptions.push({
          name: 'Audit log',
          action: () => this.context.router.push('/organisation/audit-log'),
        });
      }

      menuOptions.push({
        name: 'Log out',
        action: () => {
          authService.logout();
          this.context.router.push('/');
        },
      });

      return (
        <div>
          <Dropdown
            align="left"
            onClick={this.profileFeedback}
            content={menuOptions}
          >
            <span>
              <p>
                <a style={linkStyle}>
                  {user && user.name} {isUserSuperAdmin && <SuperAdminIcon name={user.name} />}
                  <img src={chevronSrc} alt="logout" />
                </a>
              </p>
            </span>
          </Dropdown>
          <TrialExpiredModal open={showTrialExpiredModal} username={user.name} />
        </div>
      );
    }

    return (
      <p style={errorStyle}>loading...</p>
    );
  }
}

export function mapDispatchToProps(dispatch) {
  return {
    onLoadUser: () => dispatch(getUser()),
    dispatch,
  };
}

UserHandler.propTypes = {
  isLightOnDark: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  user: state.user.user,
});

export default connect(mapStateToProps, mapDispatchToProps)(UserHandler);



/** WEBPACK FOOTER **
 ** ./src/containers/user-handler/index.js
 **/